import React from 'react';
import { observer } from 'mobx-react';
import { Help } from '../../../../../../../components/Form';
import cx from 'classnames';
import styles from './TextInput.m.sass';
export default observer(function TextInput(_ref) {
  var _vm$answer, _vm$prompt$question, _vm$validation, _vm$validation$errors, _answer$length;
  var vm = _ref.vm,
    disabled = _ref.disabled,
    _onChange = _ref.onChange;
  var answer = (_vm$answer = vm.answer) !== null && _vm$answer !== void 0 ? _vm$answer : (_vm$prompt$question = vm.prompt.question) === null || _vm$prompt$question === void 0 ? void 0 : _vm$prompt$question.answer;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.textInput
  }, /*#__PURE__*/React.createElement("textarea", {
    rows: 4,
    className: cx(styles.input, !vm.validation.isValid && styles.danger),
    value: answer,
    onChange: function onChange(e) {
      return _onChange(e.target.value);
    },
    disabled: disabled,
    "data-test": "text-answer"
  }), /*#__PURE__*/React.createElement(Help, {
    error: (_vm$validation = vm.validation) === null || _vm$validation === void 0 ? void 0 : (_vm$validation$errors = _vm$validation.errors) === null || _vm$validation$errors === void 0 ? void 0 : _vm$validation$errors.answer,
    help: "".concat(vm.MAX_TEXT_LENGTH - ((_answer$length = answer === null || answer === void 0 ? void 0 : answer.length) !== null && _answer$length !== void 0 ? _answer$length : 0), " characters remaining")
  }));
});
//# sourceMappingURL=index.js.map
